// Store for reported faults and work orders (persisted in localStorage when no backend).
const STORAGE_KEY = 'fm-faultStore';

const loadStored = () => {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    if (!raw) return { faults: [], workOrders: [] };
    const parsed = JSON.parse(raw);
    return {
      faults: Array.isArray(parsed.faults) ? parsed.faults : [],
      workOrders: Array.isArray(parsed.workOrders) ? parsed.workOrders : [],
    };
  } catch {
    return { faults: [], workOrders: [] };
  }
};

const stored = loadStored();
let extraFaults = stored.faults;
let extraWorkOrders = stored.workOrders;

const save = () => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ faults: extraFaults, workOrders: extraWorkOrders }));
    }
  } catch {}
};

export const getFaults = () => [...extraFaults];
export const getWorkOrders = () => [...extraWorkOrders];

export const addFault = (fault) => {
  const withId = { ...fault, id: `fault-${Date.now()}` };
  extraFaults.push(withId);
  save();
  return withId;
};

export const addWorkOrder = (wo) => {
  const withId = { ...wo, id: `wo-${Date.now()}` };
  extraWorkOrders.push(withId);
  save();
  return withId;
};

/**
 * Při dokončení work orderu nastaví všechny závady propojené s tímto WO na stav "resolved".
 * Propojení závada ↔ WO: stav závady se mění se stavem zakázky.
 * Audit: u vyřešených závad nastaví updatedAt a updatedBy.
 */
export const resolveFaultsByWorkOrderId = (workOrderId, updatedBy = null) => {
  const updatedAt = new Date().toISOString();
  let changed = false;
  extraFaults = extraFaults.map((f) => {
    if (f.workOrderId === workOrderId && f.status !== 'resolved') {
      changed = true;
      return { ...f, status: 'resolved', updatedAt, updatedBy };
    }
    return f;
  });
  if (changed) save();
};

export const getMergedFaults = (baseFaults) => [...(baseFaults || []), ...extraFaults];
export const getMergedWorkOrders = (baseWorkOrders) => [...(baseWorkOrders || []), ...extraWorkOrders];
